'use strict';

angular.module('app.influencerManageChannels', ['ui.router', 'angular-img-cropper', 'sotos.crop-image'])

.config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {   

        $stateProvider.
            state('oauthsuccess', {
                url: "/access_token={access_token}",
                templateUrl: 'app/profile/influencerManageChannels/partials/OAuth.html?app_v=deployDate',
                controller: 'OAuthLoginController'
            });

        $stateProvider
            .state('home.profileManageChannels', {
                requireLogin: true,
                url: 'profile/influencermanagechannels',
                templateUrl: 'app/profile/influencerManageChannels/partials/influencer-login-manage-channels.html?app_v=deployDate',
                data: {
                    authorizedRoles: ['User'],
                    navMarker: ['profileInfluencer', 'influencerManagechannels']
                },
                controller: 'ManageChannelsCtrl'
            })
}])

.controller("OAuthLoginController", function ($scope, $stateParams, $window, $state) {
    var $parentScope = $window.opener.angular.element(window.opener.document).scope();
    if (angular.isDefined($stateParams.access_token)) {
        $parentScope.$broadcast("igAccessTokenObtained", { access_token: $stateParams.access_token })
    }
    $window.close();

})

.controller('ManageChannelsCtrl', function($scope, $rootScope, $http, $modal, $location, localStorageService, $animate, adminService){
    var ls = localStorageService;
    $scope.currentUser = ls.get('currentUser');
    $scope.userName = $scope.currentUser.firstName + " " + $scope.currentUser.lastName;
    $scope.InfluencerChannels = [];
    $scope.isValidToAdd = true;
    
    $scope.loadData = function() {
        if($scope.currentUser.company.companyType.id == 6){
            var getBlogUrl = $rootScope.apiUrl + 'influencer/getInfluencerInformation/' + $scope.currentUser.company.id;
            $http.get(getBlogUrl, {loader: false})
                .success(function(response){
                    $scope.blog = response.data;
                    $scope.InfluencerChannels = response.data.influencerChannels;
            })
        }
    }

    $scope.loadData();
    $scope.$on('refreshInfluencerChannel', function(event, args){
        $scope.loadData();
    })

    $scope.PlatformIcon = function (platform_id) {
        return adminService.getPlatformIcon(platform_id);
    }

    $scope.newChannelModalHandler = function () {
        var channelModalInstance = $modal.open({       
            scope: $scope,    
            templateUrl: 'app/profile/influencerManageChannels/partials/influencer-add-channel.html?app_v=deployDate',
            controller: 'NewInfluencerChannelCtrl'
        });

        $scope.channelModalInstance = channelModalInstance;
        $scope.index = null;
        channelModalInstance.result.then(function(result){  
            if($scope.InfluencerChannels && result != null){
                $rootScope.$broadcast('refreshInfluencerChannel');   
            }               
        },function(){
            //
        });
    }

    $scope.editInfluencerChannelModalHandler = function(index){
        var editChannelModalInstance = $modal.open({       
            scope: $scope,    
            templateUrl: 'app/profile/influencerManageChannels/partials/influencer-add-channel.html?app_v=deployDate',
            controller: 'NewInfluencerChannelCtrl'
        });

        $scope.editChannelModalInstance = editChannelModalInstance;
        $scope.index = index;
        editChannelModalInstance.result.then(function(result){
            if($scope.isValidToAdd){
                if (~$scope.index) {
                    $rootScope.$broadcast('refreshInfluencerChannel');
                }
            }
            $scope.isValidToAdd = true;
            $scope.index = null;               
        },function(){
            //
        });
    }

    $scope.removeInfluencerChannel = function(index){
        var deleteChannelItem = $scope.InfluencerChannels[index];

        var indexNo = $scope.InfluencerChannels.indexOf(deleteChannelItem);

        var req = {
            url: $rootScope.apiUrl + 'channel/deleteChannel',
            method: 'POST',
            data: deleteChannelItem
        }    

        $http(req).success(function(response){
            $rootScope.$broadcast('refreshInfluencerChannel');
        })
            .error(function(response){
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = response.message;
            })
    }

    $scope.channelStatusModal = function(index){
        var channelInfo = $scope.InfluencerChannels[index];
        var authorizeChannelModalInstance = null;
        
        if(channelInfo.platform == 1){
            authorizeChannelModalInstance = $modal.open({       
                scope: $scope,    
                templateUrl: 'app/profile/influencerManageChannels/partials/influencer-manage-channel-authorization-blog.html?app_v=deployDate',
                controller: 'AuthorizeBlogCtrl'
            });
            $scope.channelHandle = channelInfo.handle;
            $scope.viewBlogAuthorization = true;
        }

        if(channelInfo.platform == 2){
            authorizeChannelModalInstance = $modal.open({       
                scope: $scope,    
                templateUrl: 'app/profile/influencerManageChannels/partials/influencer-manage-channel-authorization-instagram.html?app_v=deployDate',
                controller: 'AuthorizeInstagramCtrl'
            });
            $scope.channelHandle = channelInfo.handle;
            $scope.updateAuthorization = true;
        }

        if(channelInfo.platform == 6){
            authorizeChannelModalInstance = $modal.open({       
                scope: $scope,    
                templateUrl: 'app/profile/influencerManageChannels/partials/influencer-manage-channel-authorization-youtube.html?app_v=deployDate',
                controller: 'AuthorizeYoutubeCtrl'
            });
            $scope.channelHandle = channelInfo.handle;
            $scope.updateAuthorization = true;
        }

        $scope.authorizeChannelModalInstance = authorizeChannelModalInstance;
    }

})

.controller('NewInfluencerChannelCtrl', function ($scope, $modalInstance, $modal, $rootScope, $http, $location, localStorageService, $animate) {
    $scope.isValidToAdd = true;
    $scope.preloadData = function(){
        $scope.renderPlatform();
        if($scope.index != null && $scope.index !== undefined){
            $scope.channelName = $scope.InfluencerChannels[$scope.index].handle;
            $scope.AddOrEdit = "Edit";
        }else{
            $scope.AddOrEdit = "Add a new ";
        }
    }

    $scope.youtubeTypes = [{
        name: "User",
        ticked: true
    },{
        name: "Channel"
    }];

    $scope.youtubeTypes.forEach(function(val){
        if($scope.index != null && $scope.index !== undefined){
            if(val.name == $scope.index.youtubeType){
                val.ticked = true;
                $scope.selectedYoutubeType = val;
            } else {
                val.ticked = false;
            }
        }
    });

    $scope.renderPlatform = function(){
        var url = $rootScope.apiUrl + 'admin/getPlatform';
        $http.get(url, {loader: false})
            .success(function(response){
                $scope.platforms = response.data;
                $scope.platforms.forEach(function(val){
                    if($scope.index != null && $scope.index !== undefined){
                        if(val.id == $scope.InfluencerChannels[$scope.index].platform_id){
                            val.ticked = true;
                            $scope.selectedPlatform = val;
                            $('#selectedPlatform.multiSelect button.multiSelectButton').attr("disabled","disabled");
                        }
                    }
                })
            })
    }

    $scope.preloadData();

    $scope.addChannel = function(){
        $scope.selectedPlatform = "";
        $scope.platforms.forEach(function (val) {
            if (val.ticked === true)
                $scope.selectedPlatform = val.id;
        });

        $scope.selectedYoutubeType = "";
        $scope.youtubeTypes.forEach(function (val) {
            if (val.ticked === true)
                $scope.selectedYoutubeType = val.name;
        });

        var channel = {
            id: $scope.index == null ? null : $scope.index.id,
            platform_id: $scope.selectedPlatform,
            handle: $scope.channelName,
            youtubeType: $scope.selectedYoutubeType
        }

        var precheckChannelUrl = $rootScope.apiUrl + 'channel/precheckChannel';

        var req ={
            url: precheckChannelUrl,
            method: 'POST',
            data: JSON.stringify(channel)
        }

        $http(req).success(function(response){
            
            var authorizeChannelModalInstance = null;
            switch($scope.selectedPlatform){
                case 1:
                    authorizeChannelModalInstance = $modal.open({       
                        scope: $scope,    
                        templateUrl: 'app/profile/influencerManageChannels/partials/influencer-manage-channel-authorization-blog.html?app_v=deployDate',
                        controller: 'AuthorizeBlogCtrl'
                    });
                    $scope.channelHandle = $scope.channelName;
                    $scope.viewBlogAuthorization = false;
                    break;
                case 2:
                    authorizeChannelModalInstance = $modal.open({       
                        scope: $scope,    
                        templateUrl: 'app/profile/influencerManageChannels/partials/influencer-manage-channel-authorization-instagram.html?app_v=deployDate',
                        controller: 'AuthorizeInstagramCtrl'
                    });
                    $scope.channelHandle = $scope.channelName;
                    break;
                case 3:
                    authorizeChannelModalInstance = $modal.open({       
                        scope: $scope,    
                        templateUrl: 'app/profile/influencerManageChannels/partials/influencer-manage-channel-authorization-pinterest.html?app_v=deployDate',
                        controller: 'AuthorizePinterestCtrl'
                    });

                    break;
                case 4:
                    authorizeChannelModalInstance = $modal.open({       
                        scope: $scope,    
                        templateUrl: 'app/profile/influencerManageChannels/partials/influencer-manage-channel-authorization-Snapchat.html?app_v=deployDate',
                        controller: 'AuthorizeSnapchatCtrl'
                    });

                    break;
                case 5:
                    authorizeChannelModalInstance = $modal.open({       
                        scope: $scope,    
                        templateUrl: 'app/profile/influencerManageChannels/partials/influencer-manage-channel-authorization-twitter.html?app_v=deployDate',
                        controller: 'AuthorizeTwitterCtrl'
                    });

                case 6:
                    authorizeChannelModalInstance = $modal.open({       
                        scope: $scope,    
                        templateUrl: 'app/profile/influencerManageChannels/partials/influencer-manage-channel-authorization-youtube.html?app_v=deployDate',
                        controller: 'AuthorizeYoutubeCtrl'
                    });
                    break;
            }
            $scope.authorizeChannelModalInstance = authorizeChannelModalInstance;
            authorizeChannelModalInstance.result.then(function(result){
                if(result != null){
                    $modalInstance.close({
                        newChannel: result.newChannel
                    });  
                }               
            },function(){
                //
            });

        })
            .error(function(response){
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = response.message;
            });

    }

    $scope.saveEditChannel = function(){
        var editChannelData = {
            id: $scope.InfluencerChannels[$scope.index].id,
            handle: $scope.channelName,
            type: $scope.InfluencerChannels[$scope.index].type,
            platform_id: $scope.InfluencerChannels[$scope.index].platform_id,
            youtubeType: $scope.InfluencerChannels[$scope.index].youtubeType
        }

        var req = {
            url: $rootScope.apiUrl + 'channel/updateChannel',
            method: 'POST',
            data: JSON.stringify(editChannelData)
        }

        $http(req).success(function(response){
            $modalInstance.close({
                newChannel: response.data
            });  
        })
            .error(function(response){
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = response.message;
            })
    }

})

.controller('AuthorizeBlogCtrl', function ($scope, $modalInstance, $modal, $rootScope, $http, $location, localStorageService, $animate) {
    $scope.authorizeScript = "<script type=\"text/javascript\" src=\"http://iptracker.getachoo.com/aip_tracker.js?v=2\"></script>";

    var checkExistScript = $rootScope.apiUrl + 'influencer/checkExistScriptScript/' + $scope.channelHandle;
    $http.get(checkExistScript, {loader: false})
        .success(function(response){
            $scope.existScript = response.data;
            if($scope.existScript == false){
                $("#submit-authorize-finish").attr("disabled","disabled");
                $("#submit-authorize-finish").addClass("blog-not-have-script");
                $scope.scriptStatus = "Not Active";
                
            } else {
                $("#submit-authorize-finish").prop("disabled", false);
                $("#submit-authorize-finish").removeClass("blog-not-have-script");
                $scope.scriptStatus = "Active";
            }
        }).
        error(function(response) {
            console.log(response);
        });

    $scope.updateInstallScript = function(){
        $http.get(checkExistScript, {loader: true})
            .success(function(response){
                $scope.existScript = response.data;
                if($scope.existScript == true){
                    $("#submit-authorize-finish").prop("disabled", false);
                    $("#submit-authorize-finish").removeClass("blog-not-have-script");
                    $scope.scriptStatus = "Active";

                }
            }).
            error(function(response) {
                console.log(response);
            });
    }

    $scope.authorizeBlog = function(){
        var channelData = {
            handle: $scope.channelName,
            type: 1,
            platform_id: $scope.selectedPlatform,
            blog_id: null,
            youtubeType: $scope.selectedYoutubeType
        }

        var request = {
            url: $rootScope.apiUrl + 'channel/addChannel',
            method: 'POST', 
            data: JSON.stringify(channelData)
        }

        $http(request).success(function (response) {
            $modalInstance.close({
                newChannel: response.data
            });
        })
            .error(function (response) {
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = response.message;
            });
    }
})

.controller('AuthorizeInstagramCtrl', function ($scope, $modalInstance, $modal, $rootScope, $http, $location, localStorageService, $animate, InstagramService) {
    $scope.authorizeInstagram = function(){
        InstagramService.login();
    }

    $rootScope.$on("igAccessTokenObtained", function (evt, args) {
        if(angular.isDefined(args.access_token)) {
            if($scope.updateAuthorization) {
                var channelData = {
                    handle: $scope.channelHandle,
                    platform_id: 2,
                    token: args.access_token
                }

                var request = {
                    url: $rootScope.apiUrl + 'channel/addChannelToken',
                    method: 'POST', 
                    data: JSON.stringify(channelData)
                }

                $http(request).success(function (response) {
                    $modalInstance.close();
                    $rootScope.$broadcast('refreshInfluencerChannel');  
                })
                    .error(function (response) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
                    });

            } else {
                var channelData = {
                    handle: $scope.channelHandle,
                    type: 1,
                    platform_id: $scope.selectedPlatform,
                    blog_id: null,
                    youtubeType: $scope.selectedYoutubeType,
                    token: args.access_token
                }

                var request = {
                    url: $rootScope.apiUrl + 'channel/addChannel',
                    method: 'POST', 
                    data: JSON.stringify(channelData)
                }

                $http(request).success(function (response) {
                    $modalInstance.close({
                        newChannel: response.data
                    });
                })
                    .error(function (response) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
                    });
            }
        }
    });
})

.factory("InstagramService", function ($rootScope, $location, $http) {
    var client_id = "1fe94438001d4b14ab9b533c90950972";

    var service = {
        login: function () {
            var w = 500;
            var h = 400;

            var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
            var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

            var left = ((width / 2) - (w / 2));
            var top = ((height / 2) - (h / 2));

            var igPopup = window.open("https://instagram.com/oauth/authorize/?client_id=" + client_id +
                "&redirect_uri=" + $location.absUrl().split('#')[0] +
                "&response_type=token", "igPopup", 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
        }
    };
    return service;

})

.controller('AuthorizeYoutubeCtrl', function ($scope, $modalInstance, $modal, $rootScope, $http, $location, localStorageService, $animate, YoutubeService) {
    $scope.authorizeYoutube = function(){
        YoutubeService.login();
    }

    $rootScope.$on("igAccessTokenObtained", function (evt, args) {
        if(angular.isDefined(args.access_token)) {
            if($scope.updateAuthorization) {
                var channelData = {
                    handle: $scope.channelHandle,
                    platform_id: 6,
                    token: args.access_token
                }

                var request = {
                    url: $rootScope.apiUrl + 'channel/addChannelToken',
                    method: 'POST', 
                    data: JSON.stringify(channelData)
                }

                $http(request).success(function (response) {
                    $modalInstance.close();
                    $rootScope.$broadcast('refreshInfluencerChannel');  
                })
                    .error(function (response) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
                    });

            } else {
                var channelData = {
                    handle: $scope.channelHandle,
                    type: 1,
                    platform_id: $scope.selectedPlatform,
                    blog_id: null,
                    youtubeType: $scope.selectedYoutubeType,
                    token: args.access_token
                }

                var request = {
                    url: $rootScope.apiUrl + 'channel/addChannel',
                    method: 'POST', 
                    data: JSON.stringify(channelData)
                }

                $http(request).success(function (response) {
                    $modalInstance.close({
                        newChannel: response.data
                    });
                })
                    .error(function (response) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
                    });
            }
        }
    });
})

.factory("YoutubeService", function ($rootScope, $location, $http) {
    var client_id = "227374112766-t2k3i034f9r69fd1df8b99o81dh7stdq.apps.googleusercontent.com";

    var service = {
        login: function () {
            var w = 500;
            var h = 400;

            var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
            var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

            var left = ((width / 2) - (w / 2));
            var top = ((height / 2) - (h / 2));

            console.log($location.absUrl().split('#')[0]);
            var igPopup = window.open("https://accounts.google.com/o/oauth2/auth?client_id=" + client_id +
                "&redirect_uri=" + $location.absUrl().split('#')[0] +
                "&response_type=token&scope=https://gdata.youtube.com", "igPopup", 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
        }
    };
    return service;

})
